import React from 'react';
import { UserShape, NotificationPreferencesShape } from '../../shapes';
import PropTypes from 'prop-types';
import ToggleSwitch from '../toggle_switch';

export default class NotificationPreferencesForm extends React.Component {
  static propTypes = {
    user: UserShape,
    notificationPreferences: NotificationPreferencesShape,
    onUpdateNotificationPreferences: PropTypes.func
  }

  state = {
    deliveryMethod: this.props.notificationPreferences.get('deliveryMethod'),
    stopEverything: this.props.notificationPreferences.get('stopEverything'),
    tackArchive: this.props.notificationPreferences.get('tackArchive'),
    newFollowers: this.props.notificationPreferences.get('newFollowers'),
    wordsFromPeopleFollowed: this.props.notificationPreferences.get('wordsFromPeopleFollowed'),
    points: this.props.notificationPreferences.get('points'),
    commentsFromPeopleFollowed: this.props.notificationPreferences.get('commentsFromPeopleFollowed'),
    lastWeeksMostTacked: this.props.notificationPreferences.get('lastWeeksMostTacked'),
    likes: this.props.notificationPreferences.get('likes'),
    commentMentions: this.props.notificationPreferences.get('commentMentions')
  }

  render() {
    return (
      <div className='notification-preferences'>
        <div className='header'>
          <h2>Notification Settings</h2>
          <p className='item-meta'>Control how pushy we are.</p>
        </div>
        <form>
          { this.renderDeliveryMethod() }
          <div className="form-group">
            <div className='label-group'>
              <h5>Weekly Tack archive.</h5>
              <p className='item-meta'>A weekly test to see if you can remember a random word you finished tacking.</p>
            </div>
            <ToggleSwitch
              id={ 'tackArchive' }
              name={ 'tackArchive' }
              onChange={ e => this.handleTackArchiveChange(e) }
              checked={ this.state.tackArchive }
            />
          </div>
          <div className="form-group">
            <div className='label-group'>
              <h5>Last Weeks Most Tacked Words.</h5>
              <p className='item-meta'>Stay in the know about popular words from last week.</p>
            </div>
            <ToggleSwitch
              id={ 'lastWeeksMostTacked' }
              name={ 'lastWeeksMostTacked' }
              onChange={ e => this.handleLastWeeksMostTackedChange(e) }
              checked={ this.state.lastWeeksMostTacked }
            />
          </div>
          <div className="form-group">
            <div className='label-group'>
              <h5>New followers.</h5>
              <p className='item-meta'>Know when people follow you on Yak Tack.</p>
            </div>
            <ToggleSwitch
              id={ 'newFollowers' }
              name={ 'newFollowers' }
              onChange={ e => this.handleNewFollowersChange(e) }
              checked={ this.state.newFollowers }
            />
          </div>
          <div className="form-group">
            <div className='label-group'>
              <h5>Words from people you follow.</h5>
              <p className='item-meta'>We'll tell you when people you follow tack a new word.</p>
            </div>
            <ToggleSwitch
              id={ 'wordsFromPeopleFollowed' }
              name={ 'wordsFromPeopleFollowed' }
              onChange={ e => this.handleWordsFromPeopleFollowedChange(e) }
              checked={ this.state.wordsFromPeopleFollowed }
            />
          </div>
          <div className="form-group">
            <div className='label-group'>
              <h5>Comments from people you follow.</h5>
              <p className='item-meta'>When people you follow say something about a word, you'll know about it.</p>
            </div>
            <ToggleSwitch
              id={ 'commentsFromPeopleFollowed' }
              name={ 'commentsFromPeopleFollowed' }
              onChange={ e => this.handleCommentsFromPeopleFollowedChange(e) }
              checked={ this.state.commentsFromPeopleFollowed }
            />
          </div>
          <div className="form-group">
            <div className='label-group'>
              <h5>Mentions.</h5>
              <p className='item-meta'>When someone mentions you in a comment, we'll tell you.</p>
            </div>
            <ToggleSwitch
              id={ 'commentMentions' }
              name={ 'commentMentions' }
              onChange={ e => this.handleCommentMentionsChange(e) }
              checked={ this.state.commentMentions }
            />
          </div>
          <div className="form-group">
            <div className='label-group'>
              <h5>Likes for your tacks and comments.</h5>
              <p className='item-meta'>You tack it. You comment on it. They like it. We let you know when it happens.</p>
            </div>
            <ToggleSwitch
              id={ 'likes' }
              name={ 'likes' }
              onChange={ e => this.handleLikesChange(e) }
              checked={ this.state.likes }
            />
          </div>
          <div className="form-group">
            <div className='label-group'>
              <h5>Points.</h5>
              <p className='item-meta'>You earn points. We tell you about it.</p>
            </div>
            <ToggleSwitch
              id={ 'points' }
              name={ 'points' }
              onChange={ e => this.handlePointsChange(e) }
              checked={ this.state.points }
            />
          </div>
          <div className="form-group danger-line">
            <div className='label-group'>
              <h5>Stop everything.</h5>
              <p className='item-meta'>Shut down all notifications. This will override everything above.</p>
            </div>
            <ToggleSwitch
              id={ 'stopEverything' }
              name={ 'stopEverything' }
              onChange={ e => this.handlPauseAllTacksChange(e) }
              checked={ this.state.stopEverything }
            />
          </div>
        </form>
      </div>
    );
  }

  renderDeliveryMethod() {
    if (this.props.user.get('hasActiveMobileDevice') || (this.props.notificationPreferences.get('deliveryMethod') == 'mobile_app')) {
      return (
        <div className='form-group'>
          <div className='label-group'>
            <h5>How would you like Yak Tack to communicate with you?</h5>
            <p className='item-meta'>If you're old-fashioned, email's a good choice. But we're fans of the mobile-app option.</p>
          </div>
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="deliveryMethodOptions" id="mobile-app-radio" value="mobile_app" checked={ this.state.deliveryMethod === 'mobile_app' } onChange={ e => this.handleDeliveryMethodChange(e) }></input>
            <label className="form-check-label" htmlFor="mobile-app-radio">Mobile App</label>
          </div>
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="deliveryMethodOptions" id="email-radio" value="email" checked={ this.state.deliveryMethod === 'email' }  onChange={ e => this.handleDeliveryMethodChange(e) }></input>
            <label className="form-check-label" htmlFor="email-radio">Email</label>
          </div>

        </div>
      );
    } else return null;
  }

  updateNotificationPreferences() {
    const payload = {
      deliveryMethod: this.state.deliveryMethod,
      stopEverything: this.state.stopEverything,
      tackArchive: this.state.tackArchive,
      newFollowers: this.state.newFollowers,
      wordsFromPeopleFollowed: this.state.wordsFromPeopleFollowed,
      points: this.state.points,
      commentsFromPeopleFollowed: this.state.commentsFromPeopleFollowed,
      lastWeeksMostTacked: this.state.lastWeeksMostTacked,
      likes: this.state.likes,
      commentMentions: this.state.commentMentions
    }
    this.props.onUpdateNotificationPreferences(payload);
  }

  handleDeliveryMethodChange(e) {
    const deliveryMethod = e.currentTarget.value;
    this.setState({ deliveryMethod: deliveryMethod }, this.updateNotificationPreferences);
  }

  handlPauseAllTacksChange(e) {
    const stopEverything = e.target.checked;
    this.setState({ stopEverything: stopEverything }, this.updateNotificationPreferences);
  }

  handleTackArchiveChange(e) {
    const tackArchive = e.target.checked;
    this.setState({ tackArchive: tackArchive }, this.updateNotificationPreferences);
  }

  handleNewFollowersChange(e) {
    const newFollowers = e.target.checked;
    this.setState({ newFollowers: newFollowers }, this.updateNotificationPreferences);
  }

  handleWordsFromPeopleFollowedChange(e) {
    const wordsFromPeopleFollowed = e.target.checked;
    this.setState({ wordsFromPeopleFollowed: wordsFromPeopleFollowed }, this.updateNotificationPreferences);
  }

  handleCommentsFromPeopleFollowedChange(e) {
    const commentsFromPeopleFollowed = e.target.checked;
    this.setState({ commentsFromPeopleFollowed: commentsFromPeopleFollowed }, this.updateNotificationPreferences);
  }

  handleCommentMentionsChange(e) {
    const commentMentions = e.target.checked;
    this.setState({ commentMentions: commentMentions }, this.updateNotificationPreferences);
  }

  handlePointsChange(e) {
    const points = e.target.checked;
    this.setState({ points: points }, this.updateNotificationPreferences);
  }

  handleLikesChange(e) {
    const likes = e.target.checked;
    this.setState({ likes: likes }, this.updateNotificationPreferences);
  }

  handleLastWeeksMostTackedChange(e) {
    const lastWeeksMostTacked = e.target.checked;
    this.setState({ lastWeeksMostTacked: lastWeeksMostTacked }, this.updateNotificationPreferences);
  }
}



// WEBPACK FOOTER //
// ./src/components/notification_preferences/form.jsx